// server
export const API_BASE_URL = "https://api.brandstrek.com/api"; 

// local

// export const API_BASE_URL = "http://localhost/project-management/api"; 